import React from 'react';
import { connect } from 'dva';
import { Link, Redirect, Route, routerRedux } from 'dva/router';
import DocumentTitle from 'react-document-title';
import styles from './BlankLayout.less';
import { Input, Row, Col} from 'antd';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';

@connect(state => ({
  home: state.home,
}))
class BlankLayout extends React.PureComponent {
  state = {
    headerFlag:false,
    modalFlag:false,
    companyName: null,
    name: null,
    phone: null,
    sponsorEmail: null,
  }

  accountCreate = () => {
    window.scrollTo( 0, 2800 );
  }

  iKnow = () => {
    this.setState({ modalFlag : false})
  }

  handleFieldChange = (e, fieldName) => {
    this.setState({ [fieldName] : e.target.value})
  }
  

  sponsorApplyCreate = () => {
    this.props.dispatch({
      type: 'home/createSponsorApply',
      payload: {
        companyName: this.state.companyName,
        name: this.state.name,
        phone: this.state.phone,
        sponsorEmail: this.state.sponsorEmail,
      },
      callback : (res) => {
        this.setState({
          companyName: null,
          name: null,
          phone: null,
          sponsorEmail: null,
          modalFlag: true
        })

      }
    })
  }

  componentWillMount() {
    
  }

  componentDidMount() {
    window.addEventListener('scroll',()=>{
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop < 2){
            this.setState({
              headerFlag: false,
            })
        }else{
            this.setState({
              headerFlag: true,
            })
        }
    });
    const scrollFlag = sessionStorage.getItem('scrollFlag');
    if(scrollFlag){
        window.scrollTo( 0, 3000 );
        sessionStorage.setItem('scrollFlag', false);
    }
  }

  render() {
    const settings = {
      width: '302px',
      autoplay: true,
      speed: 1000,
      infinite: true,
      arrows:false
    };
    return (
        <div className={styles.container}>
            <div className={this.state.headerFlag ? styles.fixedHeader : styles.header}>
                <div className={styles.middle}>
                    <div className={styles.logo}>
                        <h1>网易麦穗广告</h1>
                    </div>
                    <div className={styles.login}>
                        <a className={styles.bt} onClick={this.accountCreate} >立即开户</a>
                        <Link to="/user/login">
                            <div className={styles.bt2} href="https://www.163.com">登 录</div>
                        </Link>
                    </div>
                </div>
            </div>

            <div className={styles.banner}>
                <div className={styles.middle}>
                    <div className={styles.item}>
                        <h2>网易麦穗广告</h2>
                        <h2>助力效果营销，实现大“麦”目标</h2>
                        <h3>流量优质 &nbsp;&nbsp; 定向精准 &nbsp;&nbsp; 投放安全 &nbsp;&nbsp; 货真价实的营销之选</h3>
                        <a className={styles.bt} onClick={this.accountCreate} >快速开户</a>
                    </div>
                    <div className={styles.pic}>
                    </div>
                </div>
            </div>
            <div className={styles.resources}>
                <div className={styles.middle}>
                    <div className={styles.item}>
                        <h2>独家网易资源</h2>
                        <h2>独享优质用户</h2>
                        <p>汇聚网易云音乐等独家网易优质资源，覆盖超过<i>4亿</i>高价值用户。流量优质，效果自然有保障。</p>
                    </div>
                    <div className={styles.pic}>
                        <div className={styles.carousel}>
                            <Slider {...settings} style={{width:'302px'}}>
                                <div className={styles.pic0}></div>
                                <div className={styles.pic1}></div>
                                <div className={styles.pic2}></div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.engine}>
                <div className={styles.middle}>
                    <div className={styles.pic}></div>
                    <div className={styles.item}>
                        <h2>算法数据双引擎</h2>
                        <h2>精准有效触达目标</h2>
                        <p>精准洞察用户特征、上下文特征、营销内容特征，行业领先的个性化机器推荐算法，再加上<i>网易20年</i>用户样本数据和数十种属性标签，双引擎驱动把营销信息推送给真正需要的用户。</p>
                    </div>
                </div>
            </div>
            <div className={styles.verify}>
                <div className={styles.middle}>
                    <div className={styles.item}>
                        <h2>多维度广告验证</h2>
                        <h2>真安全营销环境</h2>
                        <p>通过“<i>网易易盾反作弊体系</i>”、“可见度测量”、“第三方监控”等技术方案对营销信息进行多维度验证，大幅度提升企业营销环境的安全度。</p>
                    </div>
                    <div className={styles.pic}>
                    </div>
                </div>
            </div>
            <div className={styles.budget}>
                <div className={styles.middle}>
                    <div className={styles.pic}></div>
                    <div className={styles.item}>
                        <h2>按需定制投放</h2>
                        <h2>灵活使用预算</h2>
                        <p>您可为账户设置日预算控制成本，可按CPC或CPM灵活调整出价方式，可视化投放数据……投放的一切均可<i>按需定制</i>。 </p>
                    </div>
                </div>
            </div>
            <div className={styles.register}>
                <h2>免费注册广告主</h2>
                <h3>留下您的联系信息，我们会有专业营销顾问与您联系，一对一为您详细介绍麦穗产品和服务，帮您更高效的进行效果营销。</h3>
                <div className={styles.line}>
                    <Input className={styles.input} value={this.state.companyName} onChange={e => this.handleFieldChange(e, 'companyName')} placeholder="公司名称" />
                    <Input className={styles.input} value={this.state.name} onChange={e => this.handleFieldChange(e, 'name')} placeholder="姓名" />
                </div>
                <div className={styles.line}>
                    <Input className={styles.input} value={this.state.phone} onChange={e => this.handleFieldChange(e, 'phone')} placeholder="手机号（必填）" />
                    <Input className={styles.input} value={this.state.sponsorEmail} onChange={e => this.handleFieldChange(e, 'sponsorEmail')} placeholder="邮箱" />
                </div>
                <a className={styles.bt3} onClick={e => this.sponsorApplyCreate()} >立即提交</a>
                <div className={styles.left}></div>
                <div className={styles.right}></div>
            </div>
            <div className={styles.footer}>
                <div className={styles.copyright}>
                    <span>Copyright © 2018 &nbsp;&nbsp; | &nbsp;&nbsp; 网易出品</span>
                </div>
            </div>
            {
                this.state.modalFlag ? (
                    <div className={styles.modal}>
                        <div className={styles.icon}></div>
                        <h2>注册信息已提交成功，请等待我们联系您!</h2>
                        <a className={styles.know} onClick={this.iKnow}>我知道了</a>
                    </div>
                ) : ''
            }
            
        </div>
    );
  }
}

export default BlankLayout;
